import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
// Replace Next-auth with your auth context
import { AuthUserContext } from '../../../session';
import { CSpinner } from '@coreui/react';

const DataRequest = ({ children }) => {
      const { authUser } = useContext(AuthUserContext);
      const navigate = useNavigate();
      // Replace Next-auth session with your auth solution
      //const { user, updateUser } = useAuth();

      // useEffect(() => {
      //       const fetchData = async () => {
      //             if (authUser?.setup) {
      //                   return;
      //             }

      //             try {
      //                   const res = await fetch('/dashboard/creator/api/setup_accounts', {
      //                         method: 'POST',
      //                         headers: {
      //                               'Content-Type': 'application/json',
      //                         },
      //                   });

      //                   if (res.ok) {
      //                         await updateUser({
      //                               ...user,
      //                               setup: true,
      //                         });
      //                         window.location.reload();
      //                   }
      //             } catch (error) {
      //                   console.error('Error setting up accounts:', error);
      //             }
      //       };

      //       // Set timeout for data fetch
      //       const timer = setTimeout(() => fetchData(), 10000);

      //       // Cleanup timeout on unmount
      //       return () => clearTimeout(timer);
      // }, [authUser, updateUser]); // Added proper dependency array

      console.log('DataRequest render:', {
            hasChildren: !!children,
            childrenType: children?.type?.name,
            childrenProps: children?.props
      });

      if (!authUser) {
            return (
                  <div className="text-center">
                        <CSpinner />
                        <p>Loading user data...</p>
                  </div>
            );
      }

      return <div className="data-request-wrapper h-full w-full">{children}</div>;
};

export default DataRequest; 